export const ALLOWED_MARKET_PLACE_NFT_TYPE = Object.freeze({
  AUCTION: "auction",
  FIXED_PRICE: "fixed_price",
});
